import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, IconButton, Button, TextField, Tooltip } from '@mui/material';

import Iconify from '../../../components/iconify';
import i18n from '../../../i18n';

/**
 * Edits a flat object as named fields.
 *
 * Rows are held by the parent, not derived from the object on every render: two
 * rows may legitimately have the same key (or none yet) while someone is typing,
 * and an object cannot represent that. The parent owns the rows and collapses
 * them to an object when it emits.
 */
export default class KeyValueEditor extends React.Component {
    render() {
        const { rows, onRowChange, onRemoveRow, onAddRow, disabled } = this.props;

        return (
            <Box>
                {rows.map((row, index) => (
                    <Grid container spacing={1} key={row.id} alignItems="center" sx={{ mb: 1 }}>
                        <Grid item xs={4}>
                            <TextField
                                size="small"
                                fullWidth
                                label={index === 0 ? i18n.t('text.jsonKey') : undefined}
                                placeholder={i18n.t('text.jsonKey')}
                                value={row.key}
                                disabled={disabled}
                                onChange={(e) => onRowChange(row.id, 'key', e.target.value)}
                                InputProps={{ sx: { fontFamily: 'monospace', fontSize: 13 } }}
                            />
                        </Grid>
                        <Grid item xs={7}>
                            <TextField
                                size="small"
                                fullWidth
                                label={index === 0 ? i18n.t('text.jsonValue') : undefined}
                                placeholder={i18n.t('text.jsonValue')}
                                value={row.value}
                                disabled={disabled}
                                onChange={(e) => onRowChange(row.id, 'value', e.target.value)}
                                InputProps={{ sx: { fontFamily: 'monospace', fontSize: 13 } }}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Tooltip title={i18n.t('buttons.delete')}>
                                <span>
                                    <IconButton
                                        size="small"
                                        disabled={disabled}
                                        aria-label={i18n.t('buttons.delete')}
                                        onClick={() => onRemoveRow(row.id)}
                                    >
                                        <Iconify icon="eva:trash-2-outline" width={18} />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Grid>
                    </Grid>
                ))}

                <Button
                    size="small"
                    variant="text"
                    disabled={disabled}
                    onClick={onAddRow}
                    startIcon={<Iconify icon="eva:plus-fill" width={16} />}
                >
                    {i18n.t('buttons.addField')}
                </Button>
            </Box>
        );
    }
}

KeyValueEditor.propTypes = {
    rows: PropTypes.arrayOf(PropTypes.object).isRequired,
    onRowChange: PropTypes.func.isRequired,
    onRemoveRow: PropTypes.func.isRequired,
    onAddRow: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};
KeyValueEditor.defaultProps = { disabled: false };
